import { render, staticRenderFns } from "./assigned-extra-setting.vue?vue&type=template&id=3baf4d4e&"
import script from "./assigned-extra-setting.vue?vue&type=script&lang=ts&"
export * from "./assigned-extra-setting.vue?vue&type=script&lang=ts&"
import style0 from "./assigned-extra-setting.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports